import ExecutionDetailsCard from "~/components/build/Show/pages/summary/ExecutionDetailsCard";
import BuildContextCard from "~/components/build/Show/pages/summary/TriggerSourceCard";

export default function Overview() {
  return (
    <div className="@container/overview">
      <div className="@2xl/overview:grid-flow-col @2xl/overview:grid-cols-none @2xl/overview:auto-cols-[minmax(240px,_600px)] grid grid-cols-1 gap-4">
        <BuildContextCard />
        <ExecutionDetailsCard />
      </div>
    </div>
  );
}
